// Static, hand-picked cover art for Super Narrate's genre/kids-band cards —
// one designed image per catalog id, bundled at build time (no AI
// generation, no network fetch). Swap/add files in
// frontend/src/assets/genre_icons/ and this map to change a genre's art.
import action from '../../../../assets/genre_icons/action.jpg';
import adventure from '../../../../assets/genre_icons/adventure.jpg';
import comedy from '../../../../assets/genre_icons/comedy.jpg';
import documentary from '../../../../assets/genre_icons/documentary.jpg';
import drama from '../../../../assets/genre_icons/drama.jpg';
import explanation from '../../../../assets/genre_icons/explanation.jpg';
import facts from '../../../../assets/genre_icons/facts.jpg';
import horror from '../../../../assets/genre_icons/horror.jpg';
import inANutshell from '../../../../assets/genre_icons/in_a_nutshell.jpg';
import miniStory from '../../../../assets/genre_icons/mini_story.jpg';
import podcast from '../../../../assets/genre_icons/podcast.jpg';
import poem from '../../../../assets/genre_icons/poem.jpg';
import preK from '../../../../assets/genre_icons/pre_k.jpg';
import primary from '../../../../assets/genre_icons/primary.jpg';
import realLifeStory from '../../../../assets/genre_icons/real_life_story.jpg';
import rhymes from '../../../../assets/genre_icons/rhymes.jpg';
import scifi from '../../../../assets/genre_icons/scifi.jpg';
import thriller from '../../../../assets/genre_icons/thriller.jpg';
import upperPrimary from '../../../../assets/genre_icons/upper_primary.jpg';

const GENRE_ART = {
  action,
  adventure,
  comedy,
  documentary,
  drama,
  explanation,
  facts,
  horror,
  in_a_nutshell: inANutshell,
  mini_story: miniStory,
  podcast,
  poem,
  pre_k: preK,
  primary,
  real_life_story: realLifeStory,
  rhymes,
  scifi,
  thriller,
  upper_primary: upperPrimary,
};

export default GENRE_ART;
